import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/reset.svg
 */
const IconReset: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.747 3.134a.981.981 0 01-.26.64.97.97 0 01-.615.306l-.13.014-1.712-.049a12.047 12.047 0 012.953 7.285 12.049 12.049 0 01-2.165 7.556 12.004 12.004 0 01-6.36 4.604 11.97 11.97 0 01-7.837-.32 12.008 12.008 0 01-5.967-5.103 12.056 12.056 0 011.987-14.73A11.99 11.99 0 0110.747.005a.975.975 0 01.718.214.986.986 0 01-.513 1.743A10.04 10.04 0 005.003 4.76a10.085 10.085 0 003.359 16.606 10.03 10.03 0 0011.885-3.616 10.091 10.091 0 00-.696-12.43l.136 2.162a.982.982 0 01-.876 1.035l-.04.004a.982.982 0 01-1.045-.918L17.45 3.03l-.034-.327.03-.082-.004-.043.03-.056.035-.063.045-.047.042-.048.044-.047.052-.047.049-.005.048-.039.562-.06 4.336.117a.986.986 0 01.952 1.008l.11-.157z"
      fill="currentColor"
    />
  </svg>
);

export default IconReset;
